import { FileACL } from 'common/types';
import { FastApiAxiosInstance } from './axiosInstances';

const aliyun = {
  getUploadUrl: (params: {
    filename: string | number;
    filesize: string | number;
    contentType: string;
    acl: FileACL;
    namespace?: string;
    overseas?: boolean;
  }) =>
    FastApiAxiosInstance.post<{
      uploadId: string;
      uploadUrl: string;
      downloadUrl: string;
      fileId: string;
      headers: Record<string, string>;
    }>('api/v3/file/upload/presign/initialization', params),
  getAliChunkUploadUrl: (params: {
    filename: string;
    filesize: string;
    contentType: string;
    acl: FileACL;
    partCount: number;
    namespace?: string;
  }) =>
    FastApiAxiosInstance.post<{
      uploadId: string;
      parts: Array<{ partNumber: number; uploadUrl: string }>;
      downloadUrl: string;
      fileId: string;
    }>('/api/v3/file/upload/multipart/initialization', params),
  aliChunksComplete: (params: { fileId: string; uploadId: string }) =>
    FastApiAxiosInstance.post<void>('api/v3/file/upload/multipart/completion', params),
};
export default aliyun;
